import * as React from "react";

import primaryColour from "../../constants";
import {
  Abs,
  AbsStop,
  Accident,
  CameraEvent,
  DefectReported,
  DoorClose,
  DoorOpen,
  DriverLogoff,
  DriverLogon,
  Generic,
  GeofenceEnter,
  GeofenceExit,
  HarshBraking,
  HarshCornerLeft,
  HarshCornerRight,
  Idle,
  IgnitionOff,
  IgnitionOn,
  InspectionSubmitted,
  LocationTimeout,
  Rop,
  SpeedingStart,
  SpeedingStop,
  TrailerAttached,
  TrailerDetached,
  UnrestrainedDriving,
  Vdc,
} from "..";
import EventType from "./types";

export const getEventType = (
  eventType: EventType,
  fill: string,
  props?: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
  switch (eventType) {
    case EventType.ABS:
      return <Abs fill={fill} {...props} />;
    case EventType.ABSStop:
      return <AbsStop fill={fill} {...props} />;
    case EventType.VDC:
      return <Vdc fill={fill} {...props} />;
    case EventType.ROP:
      return <Rop fill={fill} {...props} />;
    case EventType.Accident:
      return <Accident fill={fill} {...props} />;
    case EventType.CameraEvent:
      return <CameraEvent fill={fill} {...props} />;
    case EventType.LocationTimeout:
      return <LocationTimeout fill={fill} {...props} />;
    case EventType.SpeedingStart:
      return <SpeedingStart fill={fill} {...props} />;
    case EventType.SpeedingStop:
      return <SpeedingStop fill={fill} {...props} />;
    case EventType.HarshCornerLeft:
      return <HarshCornerLeft fill={fill} {...props} />;
    case EventType.HarshCornerRight:
      return <HarshCornerRight fill={fill} {...props} />;
    case EventType.HarshBraking:
      return <HarshBraking fill={fill} {...props} />;
    case EventType.DefectReported:
      return <DefectReported fill={fill} {...props} />;
    case EventType.InspectionSubmitted:
      return <InspectionSubmitted fill={fill} {...props} />;
    case EventType.DriverLogon:
      return <DriverLogon fill={fill} {...props} />;
    case EventType.DriverLogoff:
      return <DriverLogoff fill={fill} {...props} />;
    case EventType.UnrestrainedDriving:
      return <UnrestrainedDriving fill={fill} {...props} />;
    case EventType.DoorClose:
      return <DoorClose fill={fill} {...props} />;
    case EventType.DoorOpen:
      return <DoorOpen fill={fill} {...props} />;
    case EventType.LocationEntered:
      return <GeofenceEnter fill={fill} {...props} />;
    case EventType.LocationExited:
      return <GeofenceExit fill={fill} {...props} />;
    case EventType.IgnitionOn:
      return <IgnitionOn fill={fill} {...props} />;
    case EventType.IgnitionOff:
      return <IgnitionOff fill={fill} {...props} />;
    case EventType.Idle:
      return <Idle fill={fill} {...props} />;
    case EventType.TrailerAttached:
      return <TrailerAttached fill={fill} {...props} />;
    case EventType.TrailerDetached:
      return <TrailerDetached fill={fill} {...props} />;
    default:
      return <Generic fill={fill} {...props} />;
  }
};

export interface EventMarkerProps extends React.SVGProps<SVGSVGElement> {
  eventType: EventType;
}

function SvgEventMarker(props: EventMarkerProps) {
  const { eventType, fill = primaryColour, ...svgProps } = props;
  return (
    <svg width={28} height={38} viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path
        d="M13.1913 34.9882L14 36.1002L14.8087 34.9882L24.3793 21.8286C26.0241 19.6511 27 16.9381 27 14C27 6.8203 21.1797 1 14 1C6.8203 1 1 6.8203 1 14C1 16.9381 1.97588 19.6511 3.62073 21.8287L13.1913 34.9882Z"
        fill={fill}
        stroke="white"
        strokeWidth={2}
      />
      <g transform="translate(2,2)">{getEventType(eventType, "#ffffff")}</g>
    </svg>
  );
}

export default SvgEventMarker;
